<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <!-- <img src="./assets/images/exams-tp-schedule.png"> -->
          <img src="./assets/images/Exception_Calendar_Icon.png" alt="" />
          <span>Exceptions Calendar</span>
        </p>
      </div>

      <md-card>
        <md-card-content class="exceptionCalendarScreen">
          <form class="example-form" [formGroup]="form">
            <div class="col s12 m4 l4" *ngIf="showField">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Region" mdInput formControlName="regionId" [mdAutocomplete]="region" [showDropDown]="{model: 'region', scope : this }">
                  <md-autocomplete #region="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of regionFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf=" form.controls.regionId.touched && form.controls.regionId.invalid"></p>
              </div>
            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Location Name" mdInput formControlName="locationId" [mdAutocomplete]="location" [showDropDown]="{model: 'location', scope : this }">
                  <md-autocomplete #location="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of locationFilteredOptions | async" [value]="option" class="subOptionShow">
                      <span>
                        {{ option.name }}
                        <span title="{{ option.locationAddress }}" class="locationListAddressCls">
                          <br/>{{ option.locationAddress }}</span>
                      </span>
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf=" form.controls.locationId.touched && form.controls.locationId.invalid"></p>
              </div>
            </div>
            <div class="userAccountAddressInfo">
              <p>
                <span *ngIf="addressTitle">Selected Location:</span> {{addressTitle}} </p>
            </div>
            <div class="col s12 m12 l12 admSubPageHeading">
              <p>Select Dates</p>
            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <div class="exceptionPageInputSec">
                  <md-form-field>
                    <input mdInput [mdDatepicker]="pickerFrom" placeholder="From" formControlName="fromDateTime" [min]="currentDate" readonly>
                    <md-datepicker-toggle mdSuffix [for]="pickerFrom"></md-datepicker-toggle>
                    <md-datepicker #pickerFrom></md-datepicker>
                  </md-form-field>
                  <custom-time-control [isDisable]="isFromTimeDisable" formControlName="fromTime"></custom-time-control>
                </div>
              </div>
              <md-checkbox formControlName="isFromAllDay">All day</md-checkbox>
            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <div class="exceptionPageInputSec">
                  <md-form-field>
                    <input mdInput [mdDatepicker]="pickerTo" placeholder="To" formControlName="toDateTime" [min]="minDate" readonly>
                    <md-datepicker-toggle mdSuffix [for]="pickerTo"></md-datepicker-toggle>
                    <md-datepicker #pickerTo></md-datepicker>
                  </md-form-field>
                  <custom-time-control [isDisable]="isToTimeDisable" formControlName="toTime"></custom-time-control>
                  <p class="validate" *ngIf="(form.controls.fromDateTime.invalid || form.controls.toDateTime.invalid)">
                    To date/time can't be less than From date/time</p>
                </div>
              </div>
              <md-checkbox formControlName="isToAllDay">All day</md-checkbox>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Reason" maxlength="100" formControlName="occasion">
                </md-form-field>
                <p requiredField *ngIf=" form.controls.occasion.touched && form.controls.occasion.invalid"></p>
              </div>
            </div>
          </form>
        </md-card-content>
        <md-card-actions>
          <div class="button-row">
            <button [disabled]="isAddDisable || form.invalid" md-raised-button class="glbAdminBtnCls1" (click)="onAdd()">ADD CLOSURE</button>
          </div>

          <!--confict grid starts and loaded if any-->
          <div *ngIf="conflictPaginationInfo && conflictPaginationInfo.totalRecords">
            <app-adm-manage-conflict-cases [data]="conflictData"></app-adm-manage-conflict-cases>
          </div>
          <!--conflict grid ends-->

        </md-card-actions>

      </md-card>

      <div class="year-field" [formGroup]="form">
        <strong>Closure Days Year:</strong>
        <md-select formControlName="yearControl">
          <md-option *ngFor="let option of year" [value]="option">
            {{ option}}
          </md-option>
        </md-select>
      </div>
      <!-- grid code -->
      <div class="cusPaginationContainer example-container">
        <div *ngIf="paginationInfo && paginationInfo.totalRecords == 0">
          <p class="nodataFound"> No Results Found</p>
        </div>
        <md-table class="mngLocGridSec" #table [dataSource]="dataSource" mdSort [ngClass]="{'hide-grid': paginationInfo && paginationInfo.totalRecords <= 0 }">

          <md-header-row *mdHeaderRowDef="displayedColumns"></md-header-row>
          <md-row *mdRowDef="let row; columns: displayedColumns;"></md-row>

          <!--- Note that these columns can be defined in any order.
                          The actual rendered columns are set as a property on the row definition" -->

          <ng-container mdColumnDef="day">
            <md-header-cell *mdHeaderCellDef md-sort-header>DAY</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.day}} </md-cell>
          </ng-container>

          <ng-container mdColumnDef="fromDateTime">
            <md-header-cell *mdHeaderCellDef md-sort-header>FROM DATE TIME</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.fromDateTime | dateTimeFormat : '' : element.timezone}} </md-cell>
          </ng-container>

          <ng-container mdColumnDef="toDateTime">
            <md-header-cell *mdHeaderCellDef md-sort-header>TO DATE TIME</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.toDateTime | dateTimeFormat : '' : element.timezone}} </md-cell>
          </ng-container>

          <ng-container mdColumnDef="occasion">
            <md-header-cell *mdHeaderCellDef md-sort-header>REASON</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.occasion}} </md-cell>
          </ng-container>

          <ng-container mdColumnDef="action">
            <md-header-cell *mdHeaderCellDef md-sort-header>ACTION</md-header-cell>
            <md-cell *mdCellDef="let element">
              <a (click)="onRemove(element.id)">Remove</a>
            </md-cell>
          </ng-container>
        </md-table>
      </div>

      <!-- grid code end -->
    </div>
  </div>
</section>


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-exception-calender/adm-manage-exception-calender.component.html